import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-color-dark py-24 px-24 text-white">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-16 md:mb-0">
            <h3 className="text-accent-dark text-24px">Beck Develops LLC</h3>
            <p className="text-14px">Venture Studio | Software & Innovation</p>
          </div>
          <div className="flex gap-24">
            <Link to="/" className="hover:text-accent-dark m-8">Home</Link>
            <Link to="/about" className="hover:text-accent-dark m-8">About</Link>
            <Link to="/projects" className="hover:text-accent-dark m-8">Portfolio</Link>
            <Link to="/login" className="hover:text-accent-dark m-8">Login</Link>
          </div>
        </div>
        <hr className="my-24 border-secondary-dark" />
        <div className="text-center text-14px">
          <p>&copy; {new Date().getFullYear()} Beck Develops LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

